import(/* webpackMode: "eager" */ "/github/workspace/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/github/workspace/components/theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "/github/workspace/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
